import { observable, action, runInAction, computed, makeObservable } from "mobx";
import { API } from "General/API";
import { projectsDataStore } from "Stores/ProjectsStore";
import { CoreStore } from "Stores/RESTStore/CoreStore";
import { API_URL } from "General/APIEndpoints";

class QAUnreadStore extends CoreStore {
  data: API_QACounts;

  url() {
    return "";
  }

  clear() {
    this.data = null;
  }

  constructor() {
    super();

    makeObservable(this, {
      data: observable,
      fetch: action.bound,
      approvalStage_1: computed,
      approvalStage_2: computed,
      bidderGatekeeper: computed,
      categoryApproval: computed,
      generalGatekeeper: computed,
      questioner: computed,
      specialist: computed,
    });

    this.reset();
  }

  reset() {
    this.data = null;
  }

  async fetch() {
    try {
      const response: API_QACounts = await API.getData(API_URL.QA.getQuestionCounts(projectsDataStore.projectId));
      runInAction(() => {
        this.data = response;
      });
    } catch (err) {
      throw err;
    }
  }

  get approvalStage_1() {
    return this.data?.approvalStage_1.count;
  }

  get approvalStage_2() {
    return this.data?.approvalStage_2.count;
  }

  get bidderGatekeeper() {
    return this.data?.bidderGatekeeper.count;
  }

  get categoryApproval() {
    return this.data?.categoryApproval.count;
  }

  get generalGatekeeper() {
    return this.data?.generalGatekeeper.count;
  }

  get questioner() {
    return this.data?.questioner.count;
  }

  get specialist() {
    return this.data?.specialist.count;
  }
}

const qaUnreadStore = new QAUnreadStore();

export { qaUnreadStore, QAUnreadStore };
